"use client";

/**
 * Logger que no tumba el arranque. Axiom se carga en un chunk aparte:
 * si el WebView no puede parsearlo, la app sigue renderizando.
 */
function consoleFallback(level, message, fields) {
	if (typeof console === "undefined") return;
	const fn = console[level] || console.log;
	try {
		if (fields) fn.call(console, message, fields);
		else fn.call(console, message);
	} catch (_) {}
}

let axiomLogger = null;

function call(level, message, fields) {
	try {
		if (axiomLogger && typeof axiomLogger[level] === "function") {
			axiomLogger[level](message, fields);
			return;
		}
	} catch (_) {}
	if (level === "error" || level === "warn") {
		consoleFallback(level, message, fields);
	}
}

export const logger = {
	debug: function (message, fields) {
		call("debug", message, fields);
	},
	info: function (message, fields) {
		call("info", message, fields);
	},
	warn: function (message, fields) {
		call("warn", message, fields);
	},
	error: function (message, fields) {
		call("error", message, fields);
	},
};

export function useLogger() {
	return logger;
}

export function WebVitals() {
	return null;
}

const token = process.env.REACT_APP_AXIOM_TOKEN;
const dataset = process.env.REACT_APP_AXIOM_DATASET || "guias-frontend";

if (typeof window !== "undefined") {
	Promise.all([import("@axiomhq/logging"), import("@axiomhq/js")])
		.then(function (mods) {
			const logging = mods[0];
			const js = mods[1];
			const transports = [
				new logging.ConsoleTransport({
					prettyPrint: process.env.NODE_ENV === "development",
				}),
			];
			if (token) {
				transports.unshift(
					new logging.AxiomJSTransport({
						axiom: new js.Axiom({ token: token }),
						dataset: dataset,
					}),
				);
			}
			axiomLogger = new logging.Logger({ transports: transports });
		})
		.catch(function () {});
}
